import { template as template_d57b3e9362fc4f1e91c64f7c0c93bc11 } from "@ember/template-compiler";
import TaskVariablesConfig from 'eflex/components/task-variables-config';
export default template_d57b3e9362fc4f1e91c64f7c0c93bc11(`
<TaskVariablesConfig
  @form={{@form}}
  @disabled={{@disabled}}
  @task={{@task}}
  @taskConfig={{@taskConfig}}
/>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
